import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    inactivo: false,
    rowVersion: null,
    
    tipoPresupuestoDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_TIPO_PRESUPUESTO'(state, tipoPresupuestoId) {
        state.id = tipoPresupuestoId;
        state.nombre = '';
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_TIPO_PRESUPUESTO'(state, tipoPresupuesto) {
        state.nombre = tipoPresupuesto.nombre.toUpperCase().trim();
        state.inactivo = tipoPresupuesto.inactivo;
        state.rowVersion = tipoPresupuesto.rowVersion;
    },

    'INICIALIZAR_DATOS'(state) {
        state.tipoPresupuestoDatos = [];
    },
    'SET_DATOS'(state, tipoPresupuestoDatos) {
        state.tipoPresupuestoDatos = tipoPresupuestoDatos;
    },
};

const getters = {
    getField,

    tipoPresupuesto(state) {
        return {
            id: state.id,
            nombre: state.nombre.toUpperCase().trim(),
            inactivo: state.inactivo,
            rowVersion: state.rowVersion,
        }
    }
};

const actions = {
    inicializar ( { commit }, tipoPresupuestoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TIPO_PRESUPUESTO', tipoPresupuestoId);

            if (tipoPresupuestoId != 0){
                apiAxios.get(`tipos-presupuestos/${tipoPresupuestoId}/abm`) 
                    .then(res => {
                        commit('SET_TIPO_PRESUPUESTO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },    
    save ( {} ) {
        return new Promise((resolve, reject) => {
            let tipoPresupuesto= {
                nombre: state.nombre.toUpperCase().trim(),
                inactivo: state.inactivo
            }

            let url = 'tipos-presupuestos';
            if (state.id != 0) {
                url += '/' + state.id;
                tipoPresupuesto.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, tipoPresupuesto)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    inactivar ( {}, tipoPresupuestoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`tipos-presupuestos/${tipoPresupuestoId}/inactivar`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },

    getDatos ( { commit }, tipoPresupuestoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (tipoPresupuestoId != 0) {
                apiAxios.get(`tipos-presupuestos/${tipoPresupuestoId}`) 
                    .then(res => {
                        let datos = [
                            // { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': res.data.inactivo? 'Si' : 'No', 'formato': '' },
                        ];
                        commit('SET_DATOS', datos);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}